import React, { useEffect, useState } from "react";
import Footer11 from "../shared/Footer11";
import Navbar11 from "../shared/Navbar11";
import Sidebar11 from "../shared/Sidebar11";
import config from "../../config";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { getSessionData } from "../../cache";

function Schoolprofile11() {
  const [loading, setLoading] = useState(true);
  const [formdata, setFormdata] = useState([]);
  const [admissionCountScience, setAdmissionCountScience] = useState("");
  const [admissionCountCommerce, setAdmissionCountCommerce] = useState("");
  const [admissionCountArts, setAdmissionCountArts] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    const fetchSchoolDetails = async () => {
      const token = sessionStorage.getItem("tokenclassxi");

      try {
        const response = await fetch(
          `${config.API_BASE_URL}/FetchSchoolDetailsIntermediate`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            // body: JSON.stringify({
            //   // schooL_CODE: schoolCode,
            //   loginid: "",
            //   password: "",
            // }),
          }
        );
        setLoading(false);
        const data = await response.json();
        // console.log("School Data:", data);
        setFormdata(data.data?.["intermediateStudent_data"] || "");
        setAdmissionCountScience(
          data.data?.["intermediateStudent_data"]?.science ?? "0"
        );
        setAdmissionCountArts(
          data.data?.["intermediateStudent_data"]?.arts ?? "0"
        );
        setAdmissionCountCommerce(
          data.data?.["intermediateStudent_data"]?.commerce ?? "0"
        );
      } catch (error) {
        console.error("Error fetching school profile:", error);
      }
    };

    fetchSchoolDetails();
  }, []);

  const handleSubmit = async () => {
    const token = sessionStorage.getItem("tokenclassxi");
    if (
      !admissionCountArts ||
      isNaN(admissionCountArts) ||
      !admissionCountCommerce ||
      isNaN(admissionCountCommerce) ||
      !admissionCountScience ||
      isNaN(admissionCountScience)
    ) {
      await Swal.fire({
        icon: "question",
        title: "Invalid Input",
        text: "Please enter a valid admission count.",
      });
      return;
    } else if (
      admissionCountArts === "0" &&
      admissionCountCommerce === "0" &&
      admissionCountScience === "0"
    ) {
      await Swal.fire({
        icon: "question",
        title: "Invalid Input",
        text: "Atlease one candidate should be there in any stream.",
      });
      return;
    }

    try {
      const response = await fetch(
        `${config.API_BASE_URL}/UpdateSchoolDataAdmissionCount_CL11_new`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            ARTS_COUNT: admissionCountArts,
            COMMERCE_COUNT: admissionCountCommerce,
            SCIENCE_COUNT: admissionCountScience,
          }),
        }
      );

      const result = await response.json();
      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Admission count updated successfully!",
          confirmButtonText: "OK",
        }).then((result) => {
          if (result.isConfirmed) {
            sessionStorage.setItem("class11profile", "YES");
            navigate("/class-xi-dashboard");
          }
        });

        // Reload the page to reflect changes
      } else {
        await Swal.fire({
          icon: "error",
          title: "Update Failed",
          text: result.message || "Something went wrong during update.",
        });
      }
    } catch (error) {
      console.error("Error submitting admission count:", error);
      await Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong. Please try again later.",
      });
    }
  };

  return (
    <>
      {loading && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}
      <div class="container-scroller">
        <Navbar11 />
        <div class="container-fluid page-body-wrapper">
          <Sidebar11 />
          <div class="main-panel">
            <div class="content-wrapper">
              <div class="row">
                <div class="col-md-12 mb-1">
                  <section class="content-header">
                    <h1>
                      <i class="fa fa-university"></i>&nbsp;School Profile
                    </h1>
                    <ol class="breadcrumb">
                      <li>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate("/class-xi-dashboard");
                          }}
                        >
                          <svg
                            stroke="currentColor"
                            fill="currentColor"
                            stroke-width="0"
                            viewBox="0 0 512 512"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ marginTop: "-4px" }}
                          >
                            <path d="M256 64C132.3 64 32 164.2 32 287.9c0 57 21.3 109 56.3 148.5 1.1 1.2 2.1 2.4 3.2 3.5C96.3 445 103 448 110 448c7.1 0 13.8-3 18.6-8.2 31.6-34.4 77-55.9 127.4-55.9s95.8 21.6 127.4 55.9c4.8 5.2 11.5 8.2 18.6 8.2 7 0 13.7-2.9 18.5-8.1 1.1-1.2 2.1-2.3 3.2-3.5 35-39.5 56.3-91.5 56.3-148.5C480 164.2 379.7 64 256 64zm-14 45.9c0-7.7 6.3-14 14-14s14 6.3 14 14v36c0 7.7-6.3 14-14 14s-14-6.3-14-14v-36zm-128 192H78c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14zm51.5-104.5c-5.4 5.4-14.4 5.4-19.8 0L120.2 172c-5.4-5.4-5.4-14.4 0-19.8s14.4-5.4 19.8 0l25.5 25.5c5.4 5.4 5.4 14.3 0 19.7zm160.6 34.5l-47.5 75.5c-1.9 2.6-4.3 5.1-7 7-13.5 9.7-32.3 6.5-42-7s-6.5-32.3 7-42l75.5-47.5c3.4-2.4 8.1-2.5 11.7 0 4.5 3.2 5.5 9.5 2.3 14zm40.2-34.5c-5.4 5.4-14.4 5.4-19.8 0s-5.4-14.4 0-19.8l25.5-25.5c5.4-5.4 14.4-5.4 19.8 0s5.4 14.4 0 19.8l-25.5 25.5zM434 301.9h-36c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14z"></path>
                          </svg>{" "}
                          Home&nbsp;
                        </a>
                      </li>
                      <li class="active">School Profile</li>
                    </ol>
                    <h3></h3>
                  </section>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 mb-4 stretch-card">
                  <div class="card">
                    <div class="card-header card-green">
                      <h4 class="mb-0 p-2">School Details</h4>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div
                          class="col-md-9"
                          style={{ borderRight: "1px solid #CED4DA" }}
                        >
                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group mb-3">
                                <label>School Name</label>
                                <input
                                  type="text"
                                  name="school_name"
                                  disabled
                                  class="form-control form-control-sm "
                                  value={formdata.schooL_NAME || ""}
                                />
                              </div>
                            </div>
                            <div class="col-md-3">
                              <div class="form-group mb-3">
                                <label>District Name</label>
                                <input
                                  type="text"
                                  name="district_name"
                                  disabled
                                  class="form-control form-control-sm "
                                  value={formdata.district || ""}
                                />
                              </div>
                            </div>
                            <div class="col-md-3">
                              <div class="form-group mb-3">
                                <label>Block Name </label>
                                <input
                                  type="text"
                                  name="block_name"
                                  disabled
                                  class="form-control form-control-sm "
                                  value={formdata.blocK_NAME || ""}
                                />
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-3">
                              <div class="form-group mb-3">
                                <label>Sub Division</label>
                                <input
                                  type="text"
                                  name="school_address"
                                  disabled
                                  class="form-control form-control-sm "
                                  value={formdata.divisioN_NAME || ""}
                                />
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group mb-3">
                                <label>School Address </label>
                                <input
                                  type="text"
                                  name="school_address"
                                  disabled
                                  class="form-control form-control-sm "
                                  value={formdata.sC_ADDRESS || ""}
                                />
                              </div>
                            </div>
                            <div class="col-md-3">
                              <div class="form-group mb-3">
                                <label>Category</label>
                                <input
                                  type="text"
                                  name="school_address"
                                  disabled
                                  class="form-control form-control-sm "
                                  value={formdata.typE_OF_SCHOOL || ""}
                                />
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-3">
                              <div class="form-group mb-3">
                                <label>UDISE Code </label>
                                <input
                                  type="text"
                                  name="udise_code"
                                  disabled
                                  class="form-control form-control-sm number"
                                  value={formdata.udisE_CODE || ""}
                                />
                              </div>
                            </div>
                            <div class="col-md-3">
                              <div class="form-group mb-3">
                                <label>Pin Code </label>
                                <input
                                  type="text"
                                  name="pincode"
                                  disabled
                                  class="form-control form-control-sm number "
                                  value={formdata.piN_CODE || ""}
                                  maxlength="6"
                                />
                              </div>
                            </div>
                            <div class="col-md-3">
                              <div class="form-group mb-3">
                                <label>Nearest Railway Station</label>
                                <input
                                  type="text"
                                  name="railway_station_name "
                                  disabled
                                  class="form-control form-control-sm "
                                  value={formdata.nearesT_RAILWAY_STATION || ""}
                                />
                              </div>
                            </div>
                            <div class="col-md-3">
                              <div class="form-group mb-3">
                                <label
                                  className="text-danger"
                                  style={{ fontWeight: "600" }}
                                >
                                  Allowed No. of Challan Generation
                                </label>
                                <input
                                  style={{ border: "1px solid red" }}
                                  type="text"
                                  name="railway_station_name "
                                  disabled
                                  class="form-control form-control-sm "
                                  value={formdata.challaN_LIMIT || ""}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="form-group mb-3">
                            <label>Principal Phone No</label>
                            <input
                              type="text"
                              name="p_phone_no"
                              disabled
                              class="form-control form-control-sm number "
                              value={formdata.heaD_MOBILE_NO || ""}
                              maxlength="10"
                            />
                          </div>
                          <div class="form-group mb-3">
                            <label>Principal Email ID</label>
                            <input
                              type="email"
                              name="p_email_id"
                              disabled
                              class="form-control form-control-sm "
                              value={formdata.emaiL_ADDRESS || ""}
                            />
                          </div>
                          <div class="form-group mb-3">
                            <label>
                              Total No. of Students as per Admission Register{" "}
                            </label>

                            <div class="row stream_row">
                              {getSessionData("approveD_SCI") === "YES" && (
                                <div class="col-md-4">
                                  <label>
                                    Science<span class="text-danger">*</span>
                                  </label>
                                  <input
                                    disabled={
                                      sessionStorage.getItem(
                                        "class11profile"
                                      ) === "YES"
                                    }
                                    maxlength="4"
                                    type="text"
                                    id="total_student_reg_science"
                                    name="total_student_science"
                                    class="form-control form-control-sm"
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      if (/^\d*$/.test(value)) {
                                        setAdmissionCountScience(value);
                                      }
                                    }}
                                    value={admissionCountScience || ""}
                                  />
                                </div>
                              )}
                              {getSessionData("approveD_COMM") === "YES" && (
                                <div class="col-md-4">
                                  <label>
                                    Commerce<span class="text-danger">*</span>
                                  </label>
                                  <input
                                    disabled={
                                      sessionStorage.getItem(
                                        "class11profile"
                                      ) === "YES"
                                    }
                                    type="text"
                                    id="total_student_commerce"
                                    name="total_student_commerce"
                                    class="form-control form-control-sm"
                                    maxlength="4"
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      if (/^\d*$/.test(value)) {
                                        setAdmissionCountCommerce(value);
                                      }
                                    }}
                                    value={admissionCountCommerce || ""}
                                  />
                                </div>
                              )}
                              {getSessionData("approveD_ARTS") === "YES" && (
                                <div class="col-md-4">
                                  <label>
                                    Arts<span class="text-danger">*</span>
                                  </label>
                                  <input
                                    disabled={
                                      sessionStorage.getItem(
                                        "class11profile"
                                      ) === "YES"
                                    }
                                    maxlength="4"
                                    type="text"
                                    id="total_student_reg_arts"
                                    name="total_student_reg_arts"
                                    class="form-control form-control-sm"
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      if (/^\d*$/.test(value)) {
                                        setAdmissionCountArts(value);
                                      }
                                    }}
                                    value={admissionCountArts || ""}
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {sessionStorage.getItem("class11profile") !== "YES" && (
                      <div className="card-footer">
                        <div className="text-end mt-3">
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleSubmit}
                          >
                            <i className="fa fa-save"></i> Submit Admission
                            Count
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <Footer11 />
          </div>
        </div>
      </div>
    </>
  );
}

export default Schoolprofile11;
